export default "__VITE_ASSET__B7ci6eQZ__"